export const wishlistsUrl = 'https://weddingfrontend.firebaseio.com/.json'

export const giftBoughtUrl = (wishListIdx, giftIdx) => {
  return `https://weddingfrontend.firebaseio.com/${wishListIdx}/gifts/${giftIdx}/bought.json`
}